<template>
	<div class="dashboard container">
		<top-bar />
		<div class="problemo-list" v-if="dashboard && dashboard.length">
			<div class="item row" v-for="item in dashboard" :key="item.id">
				<div class="row host">
					<div class="hostname"><strong>{{item.name}}</strong></div>
					<div class="additional">{{item.netaddress}} @ {{item.location}}</div>
				</div>

				<div class="problems">
					<problem v-for="item in item.problems" :key="item.event_id" :problem="item" />
				</div>
				
			</div>
		</div>
		<div v-if="dashboard && !dashboard.length" class="no-problemo">
			<p align="center">Нет проблем</p>
		</div>
	</div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import Problem from './Problem'
import TopBar from './TopBar'

import moment from 'moment'
import { clearInterval } from 'timers';
moment.locale('ru')

export default {
	components: {
		Problem,
		TopBar
	},

	data() {
		return {
			intervalID: null
		}
	},

	computed: {
		...mapState({
			dashboard: 'dashboard'
		}),
	},
	methods: {
		...mapActions([
			'fetchData',
			'startAutoRefresh',
			'stopAutoRefresh'
		])
	},
	mounted() {
		this.fetchData()
		this.startAutoRefresh()
	},
	destroyed() {
		//this.stopAutoRefresh()
	}
}
</script>

<style>
.host {
	margin-top: 0.5rem;
	margin-bottom: 0.3rem;
}

.host .hostname {
	color: #E5E510;
}
.host .additional {
	font-size: 85%;
	color: #737373;
}

.host .col-sm:first-of-type {
	margin-left: 0;
}

.problems .problem {
	position: relative;
	padding-left: 0.5rem;
	padding-bottom: 0.2rem;
}

.problems .problem::before {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    height: 100%;
    width: 2px;
    background-color: #454f55;
}

.problems .problem::after {
	content: '';
    position: absolute;
    z-index: 100;
    display: block;
    width: 4px;
    height: 4px;
    left: -3px;
	top: 0.25rem;
    -webkit-border-radius: 100%;
    -moz-border-radius: 100%;
    border-radius: 100%;
	border: 2px solid #2b2b2b;
    background-color: #69808d;
}

.problems .col-sm {
	display: inline;
	margin-left: 0.5rem;
}

.problems .time {
	color: #4796c4;
	
}

.problem .status.has-problem {
	color: #F00;
}

.problem .status.has-resolved {
	color: #0F0;
}



.problems .col-sm:first-of-type {
	margin-left: 0;
}


.dashboard {
	padding-top: 60px;
}

.no-problemo {
	padding: 50px 0;
}
</style>


